import { Amplify, Auth } from 'aws-amplify'

export const getCurrentAuthenticatedUser = (customContext?: typeof Amplify) => {
  const auth: typeof Auth = customContext ? customContext.Auth : Amplify.Auth
  return auth.currentAuthenticatedUser()
}
